var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 8.86665C7.91331 8.86665 7.82664 8.84665 7.74664 8.79999L1.85997 5.39332C1.62664 5.25332 1.53997 4.94665 1.67997 4.70665C1.81997 4.46665 2.12664 4.38665 2.36664 4.52665L7.99997 7.78665L13.6 4.54665C13.84 4.40665 14.1466 4.49332 14.2866 4.72665C14.4266 4.96665 14.34 5.27332 14.1066 5.41332L8.25997 8.79999C8.17331 8.83999 8.08664 8.86665 7.99997 8.86665Z",
    fill: "#2058E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.9067C7.72667 14.9067 7.5 14.68 7.5 14.4067V8.35999C7.5 8.08665 7.72667 7.85999 8 7.85999C8.27333 7.85999 8.5 8.08665 8.5 8.35999V14.4067C8.5 14.68 8.27333 14.9067 8 14.9067Z",
    fill: "#2058E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 15.1667C7.41338 15.1667 6.83338 15.04 6.37338 14.7867L2.81338 12.8067C1.84672 12.2734 1.09338 10.9867 1.09338 9.88004V6.11337C1.09338 5.00671 1.84672 3.72671 2.81338 3.18671L6.37338 1.21337C7.28672 0.706707 8.71338 0.706707 9.62672 1.21337L13.1867 3.19337C14.1534 3.72671 14.9067 5.01337 14.9067 6.12004V9.88671C14.9067 10.9934 14.1534 12.2734 13.1867 12.8134L9.62672 14.7867C9.16672 15.04 8.58672 15.1667 8.00005 15.1667ZM8.00005 1.83337C7.58005 1.83337 7.16672 1.92004 6.86005 2.08671L3.30005 4.06671C2.66005 4.42004 2.09338 5.38004 2.09338 6.11337V9.88004C2.09338 10.6134 2.66005 11.5734 3.30005 11.9334L6.86005 13.9134C7.46672 14.2534 8.53338 14.2534 9.14005 13.9134L12.7001 11.9334C13.3401 11.5734 13.9067 10.62 13.9067 9.88004V6.11337C13.9067 5.38004 13.3401 4.42004 12.7001 4.06004L9.14005 2.08004C8.83338 1.92004 8.42005 1.83337 8.00005 1.83337Z",
    fill: "#2058E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareIcon);
export default __webpack_public_path__ + "static/media/SquareIcon.06e870305f04b7f83e6cf4d4aa1eb986.svg";
export { ForwardRef as ReactComponent };